import { getHomePageUrl } from 'utils/navigation';

export const gradesBreadcrumbs = (): any => [
  {
    href: getHomePageUrl(),
    label: 'Начало',
  }
];

